import React, { useEffect, useRef, useState } from "react";
import { Calendar as BigCalendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "./Calendar.css";
import { Modal, Button, Form } from "react-bootstrap";
import {
  FaMapMarkerAlt,
  FaUser,
  FaClock,
  FaDollarSign,
  FaUserFriends,
} from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import {
  cancelOrder,
  calenderEvents,
} from "../../../../redux/slices/orderSlice";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";

const localizer = momentLocalizer(moment);

// Custom Views
const CustomToolbar = ({ label, view, onView, onNavigate, date }) => {
  const goToBack = () => {
    onNavigate("PREV");
  };

  const goToNext = () => {
    onNavigate("NEXT");
  };

  const goToCurrent = () => {
    onNavigate("TODAY");
  };

  const handleDateChange = (selectedDate) => {
    if (selectedDate) {
      const targetDate = moment(selectedDate).startOf("day");
      const currentDate = moment(date).startOf("day");
      const daysDiff = targetDate.diff(currentDate, "days");

      if (daysDiff === 0) {
        onNavigate("TODAY");
      } else {
        onNavigate("DATE", selectedDate);
      }
    }
  };

  return (
    <div className="rbc-toolbar">
      <div
        className="rbc-btn-group"
        style={{ display: "flex", alignItems: "center", gap: "8px" }}
      >
        <button
          type="button"
          onClick={goToBack}
          style={{ padding: "6px 12px", minWidth: "80px" }}
        >
          Back
        </button>
        <button
          type="button"
          onClick={goToCurrent}
          style={{ padding: "6px 12px", minWidth: "80px" }}
        >
          Today
        </button>
        <button
          type="button"
          onClick={goToNext}
          style={{ padding: "6px 12px", minWidth: "80px" }}
        >
          Next
        </button>
        <div
          style={{
            position: "relative",
            zIndex: 1000,
            display: "inline-block",
          }}
        >
          <DatePicker
            selected={moment(date).toDate()}
            onChange={handleDateChange}
            dateFormat="dd MMM yyyy"
            className="form-control"
            customInput={
              <input
                style={{
                  width: "140px",
                  height: "38px",
                  padding: "6px 12px",
                  fontSize: "14px",
                  border: "1px solid #dee2e6",
                  borderRadius: "4px",
                }}
              />
            }
            withPortal
            portalId="date-picker-portal"
          />
        </div>
      </div>
      <span className="rbc-toolbar-label">{label}</span>
      <div className="rbc-btn-group">
        <button
          type="button"
          className={view === "month" ? "rbc-active" : ""}
          onClick={() => onView("month")}
          style={{ padding: "6px 12px", minWidth: "80px" }}
        >
          Month
        </button>
        <button
          type="button"
          className={view === "week" ? "rbc-active" : ""}
          onClick={() => onView("week")}
          style={{ padding: "6px 12px", minWidth: "80px" }}
        >
          Week
        </button>
        <button
          type="button"
          className={view === "day" ? "rbc-active" : ""}
          onClick={() => onView("day")}
          style={{ padding: "6px 12px", minWidth: "80px" }}
        >
          Day
        </button>
        <button
          type="button"
          className={view === "work_week" ? "rbc-active" : ""}
          onClick={() => onView("work_week")}
          style={{ padding: "6px 12px", minWidth: "100px" }}
        >
          Trainer View
        </button>
      </div>
    </div>
  );
};

// Custom Trainer Day View
class TrainerDayView extends React.Component {
  static title(date) {
    return moment(date).format("dddd DD MMM, YYYY");
  }

  static navigate(date, action) {
    switch (action) {
      case "PREV":
        return moment(date).subtract(1, "day").toDate();
      case "NEXT":
        return moment(date).add(1, "day").toDate();
      case "TODAY":
        return new Date();
      default:
        return date;
    }
  }

  generateTimeSlots() {
    const slots = [];
    for (let i = 5; i < 24; i++) {
      slots.push(moment().startOf("day").hour(i).format("h:mm A"));
    }
    return slots;
  }

  filterEventsByDate(events, date, time, trainerId) {
    return events.filter((event) => {
      const eventDate = moment(event.start).format("YYYY-MM-DD");
      const selectedDate = moment(date).format("YYYY-MM-DD");
      const eventStartHour = moment(event.start).hour();
      const slotHour = moment(time, "h:mm A").hour();

      return (
        eventDate === selectedDate &&
        eventStartHour === slotHour &&
        event.trainerId === trainerId
      );
    });
  }

  render() {
    const { date, events, resources } = this.props;
    const timeSlots = this.generateTimeSlots();

    return (
      <div className="trainer-day-view">
        <div className="time-column">
          <div className="time-header">Time</div>
          {timeSlots.map((time) => (
            <div key={time} className="time-slot">
              {time}
            </div>
          ))}
        </div>

        <div className="trainer-columns">
          {resources.map((trainer) => (
            <div key={trainer._id} className="trainer-column">
              <div className="trainer-header">
                <img
                  src={trainer.avatarUrl || "default-avatar.png"}
                  alt={trainer.title}
                  className="trainer-avatar"
                />
                <div className="trainer-name">- {trainer.title}</div>
              </div>

              {timeSlots.map((time) => (
                <div key={`${trainer.id}-${time}`} className="trainer-cell">
                  {this.filterEventsByDate(events, date, time, trainer.id).map(
                    (event) => {
                      const eventStart = moment(event.start);
                      const eventEnd = moment(event.end);
                      const startMinutes = eventStart.minutes();
                      const duration = moment(event.end).diff(
                        event.start,
                        "minutes"
                      );

                      return (
                        <div
                          key={event.id || event.orderId}
                          className="event-item"
                          style={{
                            top: `${(startMinutes / 60) * 100}px`,
                            height: `${(duration / 60) * 100}px`,
                          }}
                          onClick={() =>
                            this.props.onSelectEvent &&
                            this.props.onSelectEvent(event)
                          }
                        >
                          <div className="event-time">
                            {moment(event.start).format("h:mm A")} -{" "}
                            {moment(event.end).format("h:mm A")}
                          </div>
                          <div className="event-title">
                            {event.customerName || event.title.split(" - ")[0]}
                          </div>
                          <div className="event-details">
                            {event.categoryName} - {event.serviceName}
                            {event.noOfPersons &&
                              ` FOR ${event.noOfPersons} ${
                                event.person || "PERSON"
                              }`}
                          </div>
                          {event.duration && `Duration: ${event.duration} mins`}
                          <div className="event-location">{event.location}</div>
                        </div>
                      );
                    }
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

const transformOrderToEvents = (order) => {
  const events = [];

  // Process trainer bookings
  order?.trainers?.forEach((trainer) => {
    const [startTime, endTime] = trainer.slotTime.split("-");
    const bookingDate = trainer.bookedDate;

    const event = {
      title: `${trainer.trainerDetails.fullName} - Private Lesson`,
      start: moment(`${bookingDate} ${startTime}`).toDate(),
      end: moment(`${bookingDate} ${endTime}`).toDate(),
      trainerId: trainer.trainerId,
      trainer: trainer.trainerDetails.fullName,
      trainerImage: trainer.trainerDetails.trainerImage,
      location: order.cartDetails[0]?.locationName || "Not specified",
      categoryName:
        order.cartDetails[0]?.categoryDetails?.categoryName || "Not specified",
      serviceName:
        order.cartDetails[0]?.serviceDetails?.serviceName || "Not specified",
      noOfPersons: order.cartDetails[0]?.serviceDetails?.noOfPersons || "",
      duration: order.cartDetails[0]?.serviceDetails?.durationOfService || "",
      person: order.cartDetails[0]?.serviceDetails?.person || "",
      price: order.cartDetails[0]?.programPrice || 0,
      maxParticipants: 1,
      currentParticipants: 1,
      description: order.cartDetails[0]?.serviceDetails?.description || "",
      orderId: order._id,
      customerName: `${order.customerDetails.firstName} ${order.customerDetails.lastName}`,
      status: order.statusOfOrder,
      allDay: false,
    };

    events.push(event);
  });

  return events;
};

const Calendar = () => {
  const dispatch = useDispatch();
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const [rescheduleReason, setRescheduleReason] = useState("");
  const { calendarEvents, refetch } = useSelector((state) => state.orderSlice);
  const [events, setEvents] = useState([]);
  const [trainers, setTrainers] = useState([]);
  const [view, setView] = useState("month");
  const [currentEventIndex, setCurrentEventIndex] = useState(0);
  const [eventsForCurrentSlot, setEventsForCurrentSlot] = useState([]);
  const prevProps = useRef({ refetch }).current;

  useEffect(() => {
    if (prevProps.refetch != refetch) {
      dispatch(calenderEvents(setIsLoading));
    }
    return () => {
      prevProps.refetch = refetch;
    };
  }, [refetch]);

  useEffect(() => {
    dispatch(calenderEvents(setIsLoading));
  }, [dispatch]);

  useEffect(() => {
    if (calendarEvents && calendarEvents.length > 0) {
      const allEvents = calendarEvents.flatMap((order) => {
        const events = transformOrderToEvents(order);
        return events.map((event) => ({
          ...event,
          allDay: false,
          end: moment(event.end).isSame(event.start, "day")
            ? event.end
            : moment(event.start).endOf("day").toDate(),
        }));
      });
      setEvents(allEvents);

      const uniqueTrainers = new Map();
      calendarEvents?.forEach((order) => {
        order?.trainers?.forEach((trainer) => {
          if (!uniqueTrainers.has(trainer.trainerId)) {
            uniqueTrainers.set(trainer.trainerId, {
              id: trainer.trainerId,
              title: trainer.trainerDetails.fullName,
              avatarUrl:
                `${process.env.REACT_APP_AWS_IMG_URL}${trainer.trainerDetails.trainerImage}` ||
                `https://ui-avatars.com/api/?name=${encodeURIComponent(
                  trainer.trainerDetails.fullName
                )}&background=random`,
            });
          }
        });
      });
      setTrainers(Array.from(uniqueTrainers.values()));
    }
  }, [calendarEvents]);

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedEvent(null);
    setCurrentEventIndex(0);
    setEventsForCurrentSlot([]);
  };

  const handleEventClick = (event, allEventsForSlot = []) => {
    if (allEventsForSlot && allEventsForSlot.length > 0) {
      setEventsForCurrentSlot(allEventsForSlot);
      setCurrentEventIndex(0);
      setSelectedEvent(allEventsForSlot[0]);
    } else {
      setSelectedEvent(event);
      setEventsForCurrentSlot([event]);
      setCurrentEventIndex(0);
    }
    // setShowModal(true);
  };

  // New function to handle trainer-specific clicks
  const handleTrainerClick = (trainer, date, time = null) => {
    let trainerEvents;

    if (time) {
      // For week/day view
      trainerEvents = events.filter((e) => {
        const eventDate = moment(e.start).format("YYYY-MM-DD");
        const eventTime = moment(e.start).format("HH:mm");
        return (
          eventDate === date &&
          eventTime === time &&
          e.trainerId === trainer.trainerId
        );
      });
    } else {
      // For month view
      trainerEvents = events.filter((e) => {
        return (
          moment(e.start).format("YYYY-MM-DD") === date &&
          e.trainerId === trainer.trainerId
        );
      });
    }

    if (trainerEvents.length > 0) {
      trainerEvents.sort(
        (a, b) => moment(a.start).valueOf() - moment(b.start).valueOf()
      );
      setEventsForCurrentSlot(trainerEvents);
      setCurrentEventIndex(0);
      setSelectedEvent(trainerEvents[0]);
      setShowModal(true);
    } else {
      console.log("No events found for trainer:", trainer.trainerId);
    }
  };

  const handleNextEvent = () => {
    if (currentEventIndex < eventsForCurrentSlot.length - 1) {
      const nextIndex = currentEventIndex + 1;
      setCurrentEventIndex(nextIndex);
      setSelectedEvent(eventsForCurrentSlot[nextIndex]);
    }
  };

  const handlePrevEvent = () => {
    if (currentEventIndex > 0) {
      const prevIndex = currentEventIndex - 1;
      setCurrentEventIndex(prevIndex);
      setSelectedEvent(eventsForCurrentSlot[prevIndex]);
    }
  };

  const eventStyleGetter = (event) => {
    let backgroundColor;
    switch (event.status) {
      case "Completed":
        backgroundColor = "green";
        break;
      case "Ongoing":
        backgroundColor = "#000985";
        break;
      case "Canceled":
        backgroundColor = "red";
        break;
      default:
        backgroundColor = "#000985"; // Default color
    }

    const style = {
      backgroundColor,
      color: "white",
      borderRadius: "4px",
      padding: "8px",
      minHeight: "120px",
      height: "auto",
      width: "95%",
      margin: "0 auto",
    };
    return { style };
  };

  const aggregateTrainerEvents = (events) => {
    const trainerCounts = {};
    events?.forEach((event) => {
      if (event.trainerId) {
        const trainerId = event.trainerId;

        if (!trainerCounts[trainerId]) {
          trainerCounts[trainerId] = {
            count: 0,
            trainer: event.trainer,
            trainerImage: event.trainerImage,
            trainerId: trainerId,
          };
        }

        // Count unique dates for this trainer
        const eventDate = moment(event.start).format("YYYY-MM-DD");
        if (!trainerCounts[trainerId].dates) {
          trainerCounts[trainerId].dates = new Set();
        }
        trainerCounts[trainerId].dates.add(eventDate);
        trainerCounts[trainerId].count++;
      }
    });

    return Object.values(trainerCounts);
  };

  const TrainerAvatarList = () => {
    const trainerStats = aggregateTrainerEvents(events);

    return (
      <div className="trainer-avatar-list">
        {trainerStats.map((data) => (
          <div key={data.trainerId} className="trainer-stat-item">
            <div className="trainer-avatar-wrapper">
              <img
                src={
                  `${process.env.REACT_APP_AWS_IMG_URL}${data.trainerImage}` ||
                  `https://ui-avatars.com/api/?name=${encodeURIComponent(
                    data.trainer
                  )}&background=random`
                }
                alt={data.trainer}
                className="trainer-stat-avatar"
              />
              <span className="trainer-booking-count">{data.count}</span>
            </div>
            <span className="trainer-name-mini">{data.trainer}</span>
          </div>
        ))}
      </div>
    );
  };

  const getTrainerColor = (trainerName) => {
    // Define specific colors for certain trainers
    const trainerSpecificColors = {
      "Paris C": "#4CAF50", // Green
      Jake: "#E91E63", // Pink
      Sarah: "#2196F3", // Blue
      Mike: "#9C27B0", // Purple
      Alex: "#00BCD4", // Cyan
    };

    // Check if trainer has a specific color assigned
    for (const [name, color] of Object.entries(trainerSpecificColors)) {
      if (trainerName.toLowerCase().includes(name.toLowerCase())) {
        return color;
      }
    }

    // If no specific color found, generate one based on trainer name
    const colors = ["#FF9800", "#607D8B", "#795548", "#FF5722", "#3F51B5"];
    const hash = trainerName
      .split("")
      .reduce((acc, char) => acc + char.charCodeAt(0), 0);
    return colors[hash % colors.length];
  };

  // New TrainerAvatar component
  const TrainerAvatar = ({ trainer, date, time = null, onClick }) => {
    const handleClick = (e) => {
      e.stopPropagation();
      e.preventDefault();
      onClick(trainer, date, time);
    };

    return (
      <div
        className="trainer-avatar-container"
        data-trainer-id={trainer.trainerId}
        data-trainer-name={trainer.trainer}
      >
        <div onClick={handleClick}>
          <span className="trainer-booking-count">{trainer.count || 1}</span>
          <img
            src={
              trainer.trainerImage
                ? `${process.env.REACT_APP_AWS_IMG_URL}${trainer.trainerImage}`
                : trainer.avatarUrl ||
                  `https://ui-avatars.com/api/?name=${encodeURIComponent(
                    trainer.trainer
                  )}&background=random`
            }
            alt={trainer.trainer}
            title={`${trainer.trainer} - ${trainer.count || 1} bookings`}
          />
        </div>
      </div>
    );
  };

  const EventComponent = ({ event, view }) => {
    // Helper function to group events by trainer
    const groupEventsByTrainer = (events) => {
      const trainerGroups = {};
      events?.forEach((evt) => {
        if (!trainerGroups[evt.trainerId]) {
          trainerGroups[evt.trainerId] = {
            count: 0,
            trainer: evt.trainer,
            trainerImage: evt.trainerImage,
            trainerId: evt.trainerId,
          };
        }
        trainerGroups[evt.trainerId].count++;
      });
      return Object.values(trainerGroups);
    };

    if (view === "month") {
      const currentDate = moment(event.start).format("YYYY-MM-DD");
      const eventsForDay = events.filter(
        (e) => moment(e.start).format("YYYY-MM-DD") === currentDate
      );

      // Only render for the first event of each day
      const isFirstEventOfDay =
        eventsForDay.length > 0 &&
        moment(event.start).isSame(
          moment.min(...eventsForDay.map((e) => moment(e.start)))
        );

      if (!isFirstEventOfDay) return null;

      const trainerGroups = groupEventsByTrainer(eventsForDay);

      return (
        <div
          className="event-content-simple"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="trainer-group">
            {trainerGroups.map((trainer) => (
              <TrainerAvatar
                key={trainer.trainerId}
                trainer={trainer}
                date={currentDate}
                onClick={handleTrainerClick}
              />
            ))}
          </div>
        </div>
      );
    }

    if (view === "week") {
      const currentDate = moment(event.start).format("YYYY-MM-DD");
      const currentTime = moment(event.start).format("HH:mm");
      const timeSlotKey = `${currentDate}-${currentTime}`;

      const eventsForTimeSlot = events.filter(
        (e) =>
          moment(e.start).format("YYYY-MM-DD") === currentDate &&
          moment(e.start).format("HH:mm") === currentTime
      );

      // Only render for the first event of the time slot
      const firstEventId = eventsForTimeSlot[0]?.orderId;
      if (event.orderId !== firstEventId) return null;

      const trainerGroups = groupEventsByTrainer(eventsForTimeSlot);

      return (
        <div
          className="event-content-simple"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          <div className="trainer-group">
            {trainerGroups.map((trainer) => (
              <TrainerAvatar
                key={trainer.trainerId}
                trainer={trainer}
                date={currentDate}
                time={currentTime}
                onClick={handleTrainerClick}
              />
            ))}
          </div>
        </div>
      );
    }

    if (view === "day") {
      const currentTime = moment(event.start).format("HH:mm");
      const currentDate = moment(event.start).format("YYYY-MM-DD");
      const trainerColor = getTrainerColor(event.trainer);

      // Get all events for this time slot
      const eventsInSameSlot = events.filter(
        (e) =>
          moment(e.start).format("YYYY-MM-DD") === currentDate &&
          moment(e.start).format("HH:mm") === currentTime
      );

      // Find index of current event in the time slot
      const eventIndex = eventsInSameSlot.findIndex(
        (e) => e.orderId === event.orderId
      );

      // Determine if it's a single trainer or multiple trainers
      const isSingleTrainer = eventsInSameSlot.length === 1;
      const trainerCount = eventsInSameSlot.length;

      return (
        <div
          className={`event-content ${isSingleTrainer ? "single-trainer" : ""}`}
          data-trainer-index={!isSingleTrainer ? eventIndex : undefined}
          data-trainer-count={!isSingleTrainer ? trainerCount : undefined}
          style={{
            backgroundColor: trainerColor,
            color: "#ffffff",
            padding: "8px",
            borderRadius: "4px",
            cursor: "pointer",
            height: "100%",
            overflow: "hidden",
          }}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            handleTrainerClick(
              {
                trainerId: event.trainerId,
                trainer: event.trainer,
                trainerImage: event.trainerImage,
              },
              currentDate,
              currentTime
            );
          }}
        >
          <div
            className="event-time"
            style={{ fontSize: "12px", fontWeight: "500", marginBottom: "4px" }}
          >
            {moment(event.start).format("h:mm A")} -{" "}
            {moment(event.end).format("h:mm A")}
          </div>
          <div
            className="event-customer"
            style={{ fontSize: "13px", fontWeight: "600", marginBottom: "4px" }}
          >
            <strong>
              {event.trainer} - {event.serviceName}
              {event.noOfPersons &&
                ` (${event.noOfPersons} ${event.person || "Person"})`}
            </strong>
          </div>
          <div
            className="event-customer"
            style={{ fontSize: "12px", marginBottom: "4px" }}
          >
            {event.customerName}
          </div>
          <div
            className="event-service"
            style={{ fontSize: "12px", marginBottom: "4px" }}
          >
            {event.categoryName} - {event.serviceName}
            {event.noOfPersons &&
              ` (${event.noOfPersons} ${event.person || "Person"})`}
          </div>
          <div
            className="event-duration"
            style={{ fontSize: "12px", marginBottom: "4px" }}
          >
            Duration: {event.duration} mins
          </div>
          <div className="event-location" style={{ fontSize: "12px" }}>
            {event.location}
          </div>
        </div>
      );
    }

    return null;
  };

  const getDayProps = (date) => {
    const eventsForDay = events.filter(
      (event) =>
        moment(event.start).format("YYYY-MM-DD") ===
        moment(date).format("YYYY-MM-DD")
    );

    if (eventsForDay.length > 0) {
      return {
        className: "rbc-has-events",
        "data-event-count": eventsForDay.length,
      };
    }
    return {};
  };

  const handleReschedule = () => {
    setShowRescheduleModal(true);
  };

  const handleRescheduleSubmit = async () => {
    toast.success("Rescheduled successfully", {
      position: "top-center",
      autoClose: 5000,
    });
    setShowRescheduleModal(false);
    setShowModal(false);
    setRescheduleReason("");
  };

  const handleCancelBooking = () => {
    dispatch(cancelOrder(selectedEvent.orderId, setIsLoading, setShowModal));
  };

  return (
    <div className="calendar-container">
      <div className="calendar-wrapper">
        <BigCalendar
          localizer={localizer}
          events={events}
          startAccessor="start"
          endAccessor="end"
          style={{ height: "auto", minHeight: "calc(100vh - 200px)" }}
          onSelectEvent={(event, e) => {
            // Safely handle the event object
            if (e && typeof e.preventDefault === "function") {
              e.preventDefault();
            }
            if (e && typeof e.stopPropagation === "function") {
              e.stopPropagation();
            }

            const currentDate = moment(event.start).format("YYYY-MM-DD");
            const currentTime = moment(event.start).format("HH:mm");

            // Always use handleTrainerClick for consistency
            handleTrainerClick(
              {
                trainerId: event.trainerId,
                trainer: event.trainer,
                trainerImage: event.trainerImage,
              },
              currentDate,
              currentTime
            );
          }}
          eventPropGetter={eventStyleGetter}
          resources={view === "work_week" ? trainers : null}
          resourceIdAccessor="id"
          resourceTitleAccessor="title"
          view={view}
          onView={setView}
          views={{
            day: true,
            week: true,
            month: true,
            work_week: TrainerDayView,
          }}
          components={{
            toolbar: CustomToolbar,
            event: (props) => <EventComponent {...props} view={view} />,
            timeGutterHeader: () => <div className="time-header">Time</div>,
          }}
          step={30}
          timeslots={2}
          defaultView="week"
          min={moment().startOf("day").hour(5).toDate()}
          max={moment().endOf("day").hour(23).minute(59).toDate()}
          formats={{
            timeGutterFormat: (date, culture, localizer) =>
              localizer.format(date, "h:mm A", culture),
            eventTimeRangeFormat: ({ start, end }, culture, localizer) => "",
          }}
          dayPropGetter={getDayProps}
        />
      </div>

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        size="lg"
        centered
        className="event-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title className="w-100">
            <div className="d-flex align-items-center gap-3">
              <div>
                <h5 className="mb-1">{selectedEvent?.trainer}</h5>
                <div className="text-muted fs-6">
                  {selectedEvent &&
                    moment(selectedEvent.start).format("dddd, MMMM D, YYYY")}
                </div>
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {eventsForCurrentSlot.length > 1 && (
            <div className="event-carousel-nav">
              <Button
                variant="outline-primary"
                onClick={handlePrevEvent}
                disabled={currentEventIndex === 0}
              >
                Previous
              </Button>
              <span className="event-counter">
                {currentEventIndex + 1} of {eventsForCurrentSlot.length}
              </span>
              <Button
                variant="outline-primary"
                onClick={handleNextEvent}
                disabled={currentEventIndex === eventsForCurrentSlot.length - 1}
              >
                Next
              </Button>
            </div>
          )}

          <div className="status-badge mb-4">
            <span
              className={`badge ${
                selectedEvent?.status === "Completed"
                  ? "bg-success"
                  : selectedEvent?.status === "Ongoing"
                  ? "bg-primary"
                  : "bg-danger"
              }`}
            >
              {selectedEvent?.status}
            </span>
          </div>

          <h6 className="section-title">Session Details</h6>
          <div className="info-grid mb-4">
            <div className="info-item">
              <FaClock className="info-icon" />
              <div>
                <strong>Time</strong>
                <p>
                  {selectedEvent &&
                    moment(selectedEvent.start).format("h:mm A")}{" "}
                  -{" "}
                  {selectedEvent && moment(selectedEvent.end).format("h:mm A")}
                </p>
              </div>
            </div>
            <div className="info-item">
              <FaMapMarkerAlt className="info-icon" />
              <div>
                <strong>Location</strong>
                <p>{selectedEvent?.location}</p>
              </div>
            </div>
            <div className="info-item">
              <FaClock className="info-icon" />
              <div>
                <strong>Duration</strong>
                <p>{selectedEvent?.duration} mins</p>
              </div>
            </div>
            <div className="info-item">
              <FaDollarSign className="info-icon" />
              <div>
                <strong>Price</strong>
                <p>${selectedEvent?.price}</p>
              </div>
            </div>
          </div>

          <h6 className="section-title">Service Information</h6>
          <div className="info-grid mb-4">
            <div className="info-item">
              <FaUser className="info-icon" />
              <div>
                <strong>Category</strong>
                <p>{selectedEvent?.categoryName}</p>
              </div>
            </div>
            <div className="info-item">
              <FaUserFriends className="info-icon" />
              <div>
                <strong>Service</strong>
                <p>{selectedEvent?.serviceName}</p>
              </div>
            </div>
          </div>

          <h6 className="section-title">Customer Information</h6>
          <div className="info-grid mb-4">
            <div className="info-item">
              <FaUser className="info-icon" />
              <div>
                <strong>Customer Name</strong>
                <p>{selectedEvent?.customerName}</p>
              </div>
            </div>
            <div className="info-item">
              <FaUserFriends className="info-icon" />
              <div>
                <strong>Participants</strong>
                <p>
                  {selectedEvent?.noOfPersons}{" "}
                  {selectedEvent?.person || "Person"}
                </p>
              </div>
            </div>
          </div>

          {selectedEvent?.description && (
            <>
              <h6 className="section-title">Description</h6>
              <p className="description-text">{selectedEvent.description}</p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          {selectedEvent?.status === "Ongoing" && (
            <>
              <Button variant="success" onClick={handleReschedule}>
                Reschedule
              </Button>

              <Button variant="danger" onClick={handleCancelBooking}>
                Cancel Booking
              </Button>
            </>
          )}
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Reschedule Modal */}
      <Modal
        show={showRescheduleModal}
        onHide={() => setShowRescheduleModal(false)}
        centered
        className="reschedule-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Reschedule Session</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Reason for Rescheduling</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={rescheduleReason}
                onChange={(e) => setRescheduleReason(e.target.value)}
                placeholder="Please provide a reason for rescheduling..."
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={handleRescheduleSubmit}
            disabled={!rescheduleReason.trim()}
          >
            Send Alert
          </Button>
          <Button
            variant="secondary"
            onClick={() => {
              setShowRescheduleModal(false);
              setRescheduleReason("");
            }}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Calendar;
